module.exports = __webpack_public_path__ + "img/selected6-min.4cbb1ab4.png";